import React from 'react';
import { NavLink } from 'react-router-dom';
import oolaLogo from '../../../Assets/oola_w.svg';
import './Sidebar.css';

const navItems = [
    {
        to: '/dashboard-v2',
        label: 'Dashboard',
        shortLabel: 'Home',
        icon: 'grid',
        end: true,
    },
    {
        to: '/dashboard-v2?tracker=1&tab=tracker',
        label: 'Action Tracker',
        shortLabel: 'Tracker',
        icon: 'target',
        isTracker: true,
    },
    {
        to: '/dashboard-v2?goals=1',
        label: 'Goals',
        shortLabel: 'Goals',
        icon: 'flag',
        isGoals: true,
    },
    {
        to: '/dashboard-v2?elearning=1&tab=breakthrough',
        label: 'E-Learning',
        shortLabel: 'Learn',
        icon: 'book',
        isElearn: true,
    },
    {
        to: '/dashboard-v2?elearning=1&tab=additional',
        label: 'Additional Programs',
        shortLabel: 'More',
        icon: 'star',
        isAdditional: true,
    },
    {
        to: '/dashboard-v2?profile=1',
        label: 'Profile',
        shortLabel: 'Profile',
        icon: 'user',
        isProfile: true,
    },
];

function isElearnActive(location) {
    const params = new URLSearchParams(location.search);
    if (params.get('elearning') === '1') return true;
    const program = params.get('program');
    return (
        program === 'breakthrough' ||
        program === 'path' ||
        program === 'additional'
    );
}

function isAdditionalActive(location) {
    const params = new URLSearchParams(location.search);
    return (
        (params.get('elearning') === '1' && params.get('tab') === 'additional') ||
        params.get('program') === 'additional'
    );
}

function isTrackerActive(location) {
    return new URLSearchParams(location.search).get('tracker') === '1';
}

function isGoalsActive(location) {
    return new URLSearchParams(location.search).get('goals') === '1';
}

function isProfileActive(location) {
    return new URLSearchParams(location.search).get('profile') === '1';
}

function NavIcon({ type }) {
    const common = {
        width: 20,
        height: 20,
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 1.7,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
    };

    switch (type) {
        case 'grid':
            return (
                <svg {...common}>
                    <rect x="3" y="3" width="7" height="7" rx="1.5" />
                    <rect x="14" y="3" width="7" height="7" rx="1.5" />
                    <rect x="3" y="14" width="7" height="7" rx="1.5" />
                    <rect x="14" y="14" width="7" height="7" rx="1.5" />
                </svg>
            );
        case 'target':
            return (
                <svg {...common}>
                    <circle cx="12" cy="12" r="8" />
                    <circle cx="12" cy="12" r="3" />
                </svg>
            );
        case 'flag':
            return (
                <svg {...common}>
                    <path d="M5 21V4" />
                    <path d="M5 4h11l-2.5 4L16 12H5" />
                </svg>
            );
        case 'book':
            return (
                <svg {...common}>
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                </svg>
            );
        case 'star':
            return (
                <svg {...common}>
                    <path d="M12 3l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 15.9 7.2 18l.9-5.4L4.2 8.7l5.4-.8L12 3z" />
                </svg>
            );
        case 'user':
            return (
                <svg {...common}>
                    <circle cx="12" cy="8" r="4" />
                    <path d="M4 20c1.5-3.5 4-5 8-5s6.5 1.5 8 5" />
                </svg>
            );
        default:
            return null;
    }
}

const Sidebar = () => (
    <aside className="dv2-sidebar">
        <div className="dv2-sidebar__brand">
            <img src={oolaLogo} alt="Oola Life" className="dv2-sidebar__logo" />
        </div>
        <nav className="dv2-sidebar__nav" aria-label="Dashboard">
            {navItems.map((item) => (
                <NavLink
                    key={item.label}
                    to={item.to}
                    exact={item.end}
                    className="dv2-sidebar__link"
                    activeClassName="dv2-sidebar__link--active"
                    aria-label={item.label}
                    isActive={(match, location) => {
                        if (item.isTracker) {
                            return isTrackerActive(location);
                        }
                        if (item.isGoals) {
                            return isGoalsActive(location);
                        }
                        if (item.isProfile) {
                            return isProfileActive(location);
                        }
                        if (item.isElearn) {
                            return (
                                isElearnActive(location) &&
                                !isAdditionalActive(location)
                            );
                        }
                        if (item.isAdditional) {
                            return isAdditionalActive(location);
                        }
                        if (item.end) {
                            return (
                                Boolean(match) &&
                                !isElearnActive(location) &&
                                !isTrackerActive(location) &&
                                !isGoalsActive(location) &&
                                !isProfileActive(location)
                            );
                        }
                        return Boolean(match);
                    }}
                >
                    <span className="dv2-sidebar__icon">
                        <NavIcon type={item.icon} />
                    </span>
                    <span className="dv2-sidebar__label">{item.label}</span>
                    <span className="dv2-sidebar__label-short" aria-hidden>
                        {item.shortLabel || item.label}
                    </span>
                    <span className="dv2-sidebar__tip" aria-hidden>
                        {item.label}
                    </span>
                </NavLink>
            ))}
        </nav>
        <div className="dv2-sidebar__quote dv2-glass">
            <div className="dv2-sidebar__quote-icon" aria-hidden>
                ▲
            </div>
            <p>
                Focus on your journey, not the destination. Progress every day.
            </p>
        </div>
    </aside>
);

export default Sidebar;
